(() => {
  const addVariant = async (variantId, context, button) => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));

    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'מוסיף...';

    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || 'add');

      if (context === 'page') {
        window.location.reload();
        return;
      }

      const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('cart');
      const cart = await cartResponse.json();
      cart.sections = json.sections || {};
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
      }));
      button.textContent = 'נוסף';
    } catch (error) {
      button.textContent = 'נסו שוב';
      window.setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1600);
      return;
    }
    button.disabled = false;
  };

  const jumpToBundleRecommendations = (button) => {
    const drawer = button.closest('cart-drawer');
    const page = button.closest('.regista-cart-section');
    const scope = drawer || page || document;
    const target = scope.querySelector('.regista-cart-cross-sell-he');

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.remove('is-highlighted');
      window.setTimeout(() => target.classList.add('is-highlighted'), 80);
      window.setTimeout(() => target.classList.remove('is-highlighted'), 1500);
      return;
    }

    window.location.href = '/collections/all';
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-cross-sell-add]');
    if (addButton) {
      const section = addButton.closest('[data-regista-cart-cross-sell-he]');
      addVariant(addButton.dataset.crossSellAdd, section ? section.dataset.context : 'drawer', addButton);
      return;
    }

    const jumpButton = event.target.closest('[data-regista-cart-bundle-jump]');
    if (jumpButton) {
      event.preventDefault();
      jumpToBundleRecommendations(jumpButton);
    }
  });
})();
